import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Zone } from '../../../app/admin/models/zone.model'
@Injectable({
  providedIn: 'root'
})
export class RodjendanskezoneService {

  private paginationSource = new ReplaySubject<any>(1);
  paginationSettings$ = this.paginationSource.asObservable();

  apiUrl = environment.apiUrl;
  private zonaSource = new ReplaySubject<any>(1);
  $zona = this.zonaSource.asObservable();
  constructor(private http: HttpClient) { }

  addZone(zone: Zone) {
    console.log("servisramp")
    console.log(zone)
    return this.http.post(this.apiUrl + 'BirthDayZone', { ...zone });
  }
  editZone(zone) {

    return this.http.put(`${this.apiUrl}BirthDayZone/${zone.id}`, zone);

  }

  getAllZone(queryParams = { currentPage: 0, itemsPerPage: 0, ZoneNameQuery: '', MaxChildNumbereQueryMin: '', MaxChildNumbereQueryMax: '', MaxAdultNumberQueryMin: '', MaxAdultNumberQueryMax: '', RoomNameQuery: '' }) {
    console.log('GETALL SERVICE')

    let params = new HttpParams();
    params = params.append('ZoneNameQuery', queryParams.ZoneNameQuery);
    params = params.append('MaxChildNumbereQueryMin', queryParams.MaxChildNumbereQueryMin);
    params = params.append('MaxChildNumbereQueryMax', queryParams.MaxChildNumbereQueryMax);
    params = params.append('MaxAdultNumberQueryMin', queryParams.MaxAdultNumberQueryMin);
    params = params.append('MaxAdultNumberQueryMax', queryParams.MaxAdultNumberQueryMax);
    params = params.append('RoomNameQuery', queryParams.RoomNameQuery);
    params = params.append('pageNumber', queryParams.currentPage);
    params = params.append('pageSize', queryParams.itemsPerPage);
    console.log('GETALL SERVICE ZoneNameQuery params', params)
    console.log('GETALL SERVICE ZoneNameQuery ', queryParams.ZoneNameQuery)
    return this.http.get(this.apiUrl + 'BirthDayZone/SearchBirthdayZones', { params, observe: 'response' }).pipe(map((zona: any) => {
      if (zona) {
        this.paginationSource.next(JSON.parse(zona.headers.get('pagination')));
        this.zonaSource.next(zona.body);
      }
    })).toPromise();
  }
  getAllPlayroomZonesSub(queryParams = {currentPage: 0, itemsPerPage: 0}): Observable<Zone[]> {
    let params = new HttpParams();
    params = params.append('pageNumber', queryParams.currentPage);
    params = params.append('pageSize', queryParams.itemsPerPage);
  return this.http.get<Zone[]>(this.apiUrl + 'BirthDayZone/SearchBirthdayZones',{params});
}

deleteZone(id) {
  return this.http.delete(`${this.apiUrl}BirthDayZone/${id}`);
}

}
